import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../core/constants/routes.constants';
import { ButtonRow } from '@omnigenbiodata/ui';

interface ButtonsProps {
  forwardLabel: string;
  backLabel?: string;
  onForward: () => void;
  onBack?: () => void;
  backButton?: boolean;
}

function Buttons({ forwardLabel, onForward, backLabel = 'Home', onBack, backButton }: ButtonsProps) {
  const navigate = useNavigate();
  const goHome = () => navigate(ROUTES.root);
  const goBack = () => navigate(-1);
  return (
    <ButtonRow
      backIcon={null}
      forwardIcon={null}
      buttonSize="large"
      backLabel={backButton ? 'Back' : backLabel}
      forwardLabel={forwardLabel}
      onForward={onForward}
      onBack={backButton ? goBack : onBack || goHome}
      forwardColor="primary"
    />
  );
}

export default Buttons;
